import styled from 'styled-components';
import { Form as UnstyledForm, InputRow as UnstyledInputRow } from 'components/Form';
import { Notification as SBNotification } from '@econsult/econsult-ui/dist/components/Notification';
import StyledButton from '@econsult/econsult-ui/dist/components/Button/ButtonStyles';

export const Notification = styled(SBNotification)`
  flex: 0;
`;

export const InputRow = styled(UnstyledInputRow)`
  display: grid;
  grid-template-columns: ${({ itemsCount }) => `1fr repeat(${itemsCount}, 1fr)`};

  & > ${StyledButton} {
    margin-left: initial;
    align-self: end;
    justify-self: end;
    grid-area: 2 / 4 / 3 / 5;
  }
`;

export const Form = styled(UnstyledForm)`
  margin-bottom: 1.5rem;
`;
